import {useEffect, useState} from 'react';
import {useSDK} from "@contentful/react-apps-toolkit";
import {config} from "../config/app-config";

const useAutocompleteItems = (accessToken) => {
    const sdk = useSDK();
    const tournamentId = sdk.entry.fields.tournamentId.getValue();
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const instanceParams = sdk.parameters.instance;
        const mode = instanceParams.mode;
        const installationParams = sdk.parameters.installation;
        const apiUrl = mode === 'tournaments' ? `${config[installationParams.environment].api}/tournaments` :
            `${config[installationParams.environment].api}/tournaments/${tournamentId}/${instanceParams.mode}`;

        if (mode !== 'tournaments' && !tournamentId) {
            return;
        }

        const fetchItems = async () => {
            if (!accessToken) return;

            try {
                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setItems(data);
            } catch (error) {
                setError(error);
                console.error('Error fetching tournaments:', error);
            }
        };

        fetchItems();
    }, [accessToken, sdk.parameters.installation, sdk.parameters.instance, tournamentId]);

    return {items, error};
};

export default useAutocompleteItems;
